import { Component, ChangeDetectionStrategy } from '@angular/core';

/** Pot ou jardinière : un pot et sa pousse. */
@Component({
    selector: 'vw-pot-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12h14l-1.6 8.2a1 1 0 0 1-1 .8H7.6a1 1 0 0 1-1-.8z"/>
    <path d="M12 12V8"/><path d="M12 8c0-2.5 1.8-4 4.5-4 0 2.5-1.8 4-4.5 4z"/><path d="M12 9.5C12 7.6 10.6 6.5 8.5 6.5c0 1.9 1.4 3 3.5 3z"/>
    </svg>`
})
export class PotIconComponent {
}
